<template>
  <div id="bottom">
    <!-- 底部 -->
    <div class="footer">
      <div class="foot">
        <div class="foot_m">
          <div class="item-msd">
            <div class="items-gs" @click="handlePathHome">
              <img src="@/assets/introduce/image_gs.png" />
              <div>
                <p class="font-Dec">湖北中潮教育科技集团有限公司</p>
                <p class="font-So fl">
                  China Trend Educational Technology Group Co. LTD
                </p>
              </div>
            </div>
            <div class="items-jh" @click="gotoOrgan">
              <img src="@/assets/introduce/Pic-mhd.png" />
              <div>
                <p class="font-Dec">明商道——创建企业大学，占领商道制高点</p>
                <p class="font-So ft">
                  全方位一站式内培平台，搭建持续学习能力提升的生态系统
                </p>
              </div>
            </div>
          </div>
          <div class="item-qt">
            <div class="items-jhs" @click="gotoSaas">
              <img src="@/assets/introduce/Pic-mzd.png" />
              <div>
                <p class="font-Dec">明职道——弘扬职业精神 打造职道竞争力</p>
                <p class="font-So ft lt">
                  过千门各行各业的视频课程，助您职场竞争力提升MAX
                </p>
              </div>
            </div>
            <div class="items-jhp" @click="gotoSupply">
              <img src="@/assets/introduce/Pic-msd.png" />
              <div>
                <p class="font-Dec">明师道——重构知识体系 引领师道新潮流</p>
                <p class="font-So ft lt">
                  发布您的优秀课程，拥有千万学子，完成传道授业解惑
                </p>
              </div>
            </div>
          </div>
          <div class="item-ewm">
            <img src="@/assets/introduce/logo-wm.png" />
            <p>中潮教育服务号</p>
          </div>
          <div class="item-ewm">
            <img src="@/assets/introduce/xcx1.png" />
            <p>明商道小程序二维码</p>
          </div>
        </div>
        <div class="foot-n">
          <a href="https://beian.miit.gov.cn/#/Integrated/index">
            Copyright ©2015-2021 版权所有湖北中潮教育科技集团有限公司
            鄂ICP备15017598号-1（中潮教育融e学）
          </a>
          <p class="Powerby">Powered by 中潮教育</p>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {};
  },
  methods: {
    handlePathHome() {
      // window.open("https://www.chn-trend.com/#/home");
    },
    gotoOrgan() {
      window.open("https://business.i-ronge.com/#/indexPage");
    },
    gotoSaas() {
      window.open("https://vocation.i-ronge.com/#/index");
    },
    gotoSupply() {
      window.open("https://master.i-ronge.com/dashbord");
    }
  }
};
</script>
<style scoped>
.footer {
  height: 350px;
  background: #333333;
  display: flex;
  justify-content: center;
}
.foot {
  width: 1200px;
}
.footer a {
  color: #666;
}
.foot_m {
  display: flex;
  justify-content: space-between;
  padding-top: 45px;
}
.item-msd {
  font-family: "Alibaba PuHuiTi, Alibaba PuHuiTi-Regular";
  font-weight: 400;
  text-align: left;
}
.font-Comp {
  font-size: 21px;
  color: #ffffff;
  line-height: 43px;
}
.font-Dec {
  font-size: 16px;
  color: #ffffff;
  font-weight: 400px;
  line-height: 16px;
  margin-top: 10px;
}
.font-So {
  font-size: 12px;
  color: #bdbdbd;
  line-height: 18px;
}
.items-jh {
  margin-top: 33px;
  display: flex;
  cursor: pointer;
}
.items-jh img {
  width: 62px;
  height: 62px;
  margin-right: 13px;
}
.item-ewm {
  /* margin-left: 50px; */
  margin-top: 13px;
}
.item-ewm img {
  width: 126px;
  height: 126px;
}
.item-ewm p {
  text-align: center;
  font-size: 14px;
  font-family: "Alibaba PuHuiTi, Alibaba PuHuiTi-Regular";
  font-weight: 400;
  color: #bdbdbd;
  line-height: 14px;
  padding-top: 10px;
}
.items-gs {
  display: flex;
  cursor: pointer;
}
.items-gs img {
  width: 62px;
  height: 62px;
  margin-right: 13px;
}
.items-jhs {
  display: flex;
  cursor: pointer;
}
.items-jhs img {
  width: 62px;
  height: 62px;
  margin-right: 13px;
}
.items-jhp {
  display: flex;
  margin-top: 33px;
  cursor: pointer;
}
.items-jhp img {
  width: 62px;
  height: 62px;
  margin-right: 13px;
}
.foot-n {
  margin-top: 50px;
  text-align: center;
}
.help {
  font-size: 12px;
  font-family: "Alibaba PuHuiTi, Alibaba PuHuiTi-Regular";
  font-weight: 400;
  color: #949494;
}
.help span {
  margin-left: 63px;
}
.foot-n a {
  display: block;
  text-decoration: none;
  font-size: 12px;
  margin-top: 5px;
  line-height: 12px;
}
.Powerby {
  font-size: 12px;
  color: #666;
  text-align: center;
  margin-top: 10px;
  line-height: 12px;
}
.fl {
  padding-top: 10px;
}
.ft {
  padding-top: 15px;
}
/* .lt {
  padding-left: 5px;
} */
</style>



// WEBPACK FOOTER //
// src/views/introducePage/component/footer.vue